const ARTWORK_AUTOMATION_FAILED_MESSAGE =
  "Art automation failed, see print areas:";

const getCustomizationAreaDatabaseId = id => atob(id).split(":")[1];

const getTrimmedText = (...values) => {
  const value = values.find(
    candidate => typeof candidate === "string" && candidate.trim()
  );

  return value ? value.trim() : "";
};

const formatFailedCustomizationAreaLine = ({
  id,
  reason,
  failReason,
  failureReason,
  details,
  additionalInformation
}) => {
  const customizationAreaId = getCustomizationAreaDatabaseId(id);
  const trimmedReason = getTrimmedText(reason, failReason, failureReason);

  if (!trimmedReason) {
    return customizationAreaId;
  }

  const trimmedDetails = getTrimmedText(details, additionalInformation);

  if (trimmedReason === "Other" && trimmedDetails) {
    return `${customizationAreaId} - ${trimmedReason} - ${trimmedDetails}`;
  }

  return `${customizationAreaId} - ${trimmedReason}`;
};

const buildArtworkChangeRequestDescription = failedCustomizationAreas =>
  `${ARTWORK_AUTOMATION_FAILED_MESSAGE}\n- ${failedCustomizationAreas
    .map(formatFailedCustomizationAreaLine)
    .join("\n- ")}`;

export default buildArtworkChangeRequestDescription;
